import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTableBar from 'components/organisms/Bars/EntitiesTableBar/EntitiesTableBar';

const StyledDatabaseEntitiesTableBar = styled(EntitiesTableBar)`
  ${ComponentStyles}
`;

StyledDatabaseEntitiesTableBar.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntitiesTableBar;
